import React, { SVGProps, forwardRef, Ref } from 'react';

type Props = {
  title?: React.ReactNode;
  titleId?: string;
} & SVGProps<SVGSVGElement>;

function SvgLuminai({ title, titleId, ...props }: Props, svgRef?: Ref<SVGSVGElement>): JSX.Element {
  return (
    <svg
      viewBox="0 0 91.38 106.65"
      width="1em"
      height="1em"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <defs>
        <style>{'.cls-1 {fill: #e2001a;}'}</style>
      </defs>
      <path
        className="cls-1"
        d="M89.88,46.18c-21.1-5.83-25.49-10.22-31.32-31.32-.25-.88-1.05-1.5-1.96-1.5s-1.72.61-1.96,1.5c-5.83,21.1-10.22,25.49-31.32,31.32-.88.25-1.5,1.05-1.5,1.96s.61,1.72,1.5,1.96c21.1,5.83,25.49,10.21,31.32,31.32.25.88,1.05,1.5,1.96,1.5s1.72-.61,1.96-1.5c5.83-21.1,10.21-25.49,31.32-31.32.88-.25,1.5-1.05,1.5-1.96s-.61-1.72-1.5-1.96Z"
      />
      <path
        className="cls-1"
        d="M8.04,19.28c9.54,2.63,11.22,4.32,13.85,13.85.25.88,1.05,1.5,1.96,1.5s1.72-.61,1.96-1.5c2.63-9.54,4.32-11.22,13.85-13.85.88-.25,1.5-1.05,1.5-1.96s-.61-1.72-1.5-1.96c-9.54-2.63-11.22-4.32-13.85-13.85-.25-.88-1.05-1.5-1.96-1.5s-1.72.61-1.96,1.5c-2.63,9.54-4.32,11.22-13.85,13.85-.88.25-1.5,1.05-1.5,1.96s.61,1.72,1.5,1.96Z"
      />
      <path
        className="cls-1"
        d="M41.86,83c-12.41-3.42-14.8-5.81-18.22-18.22-.25-.88-1.05-1.5-1.96-1.5s-1.72.61-1.96,1.5c-3.42,12.41-5.81,14.8-18.22,18.22-.88.25-1.5,1.05-1.5,1.96s.61,1.72,1.5,1.96c12.41,3.42,14.8,5.81,18.22,18.22.25.88,1.05,1.5,1.96,1.5s1.72-.61,1.96-1.5c3.42-12.41,5.81-14.8,18.22-18.22.88-.25,1.5-1.05,1.5-1.96s-.61-1.72-1.5-1.96Z"
      />
    </svg>
  );
}

export default forwardRef(SvgLuminai);
